export const getIndicatorPosition = (
  prevCoefficient: number | undefined,
  coeficient: number
): string => {
  const prevCoeffFiltered = +(prevCoefficient || 0);

  if (!prevCoefficient) {
    return '';
  }

  if (+coeficient > prevCoeffFiltered) {
    return 'up';
  } else if (+coeficient < prevCoeffFiltered) {
    return 'down';
  }

  return '';
};
